let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("9RBOx")).then(() => parcelRequire('68eav'));